var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel panel-default ls-flex-column fill" }, [
    _c("div", { staticClass: "panel-heading" }, [
      _c("div", { staticClass: "pagetitle h3" }, [
        _vm._v(" " + _vm._s(_vm._f("translate")("Select attachement")) + " ")
      ]),
      _c("div", { staticClass: "h4" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm._f("translate")(
                "To add files please open the resources tab, or ask an administrator to add files to the survey folder"
              )
            ) +
            " "
        )
      ])
    ]),
    _c("div", { staticClass: "panel-body ls-flex-column grow-1 fill" }, [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          !_vm.loading && _vm.filesAvailable
            ? _c(
                "div",
                { staticClass: "masonry-container" },
                _vm._l(_vm.availableFilesList, function(file) {
                  return _c(
                    "div",
                    {
                      key: file.shortName,
                      staticClass:
                        "ls-flex ls-flex-column scoped-file-tile scoped-file-icon",
                      class: _vm.isSelected(file) ? "scope-selected-file" : "",
                      attrs: { id: "iconRep-" + file.hash }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ls-flex ls-flex-row align-content-center align-items-center emailtemplates--imagecontainer",
                          on: {
                            click: function($event) {
                              return _vm.toggleFileSelection(file)
                            }
                          }
                        },
                        [
                          file.isImage
                            ? _c("img", {
                                staticClass: "scoped-contain-image",
                                attrs: { src: file.src, alt: file.shortName }
                              })
                            : _c("i", {
                                class:
                                  "fa " +
                                  file.iconClass +
                                  " fa-4x scoped-big-icon"
                              })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "scoped-prevent-overflow ls-space margin top-5"
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(file.shortName) +
                              "\n                    "
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          !_vm.loading && !_vm.filesAvailable
            ? _c("div", { attrs: { id: "fileSelectorLoader" } }, [
                _c("p", { staticClass: "well" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("translate")("No files in the survey folder")
                      )
                  )
                ])
              ])
            : _vm._e(),
          _vm.loading
            ? _c("loader-widget", { attrs: { id: "fileSelectorLoader" } })
            : _vm._e()
        ],
        1
      )
    ]),
    _c("div", { staticClass: "panel-footer" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-success",
              attrs: { id: "emailtemplates--save-attachements" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.saveAttachments($event)
                }
              }
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm._f("translate")("Save selection")) +
                  "\n                "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }